<template>
<modal :name="name" :adaptive="true" height="auto" @before-open="beforeOpen">
  <div class="nmodal">

    <h1>{{status}}</h1>

    <h2>{{msg}}</h2>

    <div @click="closeModal" class="apmodalbtn gettheguide">Ok</div>

  </div>
</modal>
</template>

<script>
import Button from '@/components/forms/Button.vue';

export default {
  name: 'NotificationModal',
  components: {
    Button,
  },
  props: {
    name: null,
    status: null,
    msg: null,
  },
  data() {
    return {
      displayMsg: '',
    };
  },
  computed: {},
  methods: {
    beforeOpen(event) {
      if (!!event && !!event.params) {
        this.$emit('before-open', event);
      }
    },
    closeModal() {
      this.$modal.hide(this.name);
      if (this.status == 'Success') {
        window.close();
      }
    },
  },
  created() {
  },
};
</script>

<style scoped lang="scss">
.nmodal {
    padding: 10px 20px;

    h1 {
      font-weight: bold;
      font-size: 20px;
    }

    h2 {
      margin: 20px 0 30px;
    }

    .apmodalbtn {
        width: 100px;
        margin: 0 auto 5px;
        cursor: pointer;
        padding: 15px 10px;
        text-align: center;
        color: #fff;
        font-weight: bold;
        border-radius: 5px;
        background-color: #545454;

        &:hover {
            background-color: #6b6b6b;
        }
    }

}
</style>
